// import type { AppState } from '../../common/types';

import type { ArchiveResponse } from '../types';

export const getArchiveWidgetData = (state: any) =>
  state.archiveWidget as ArchiveResponse;
